/* src/app/pages/data-compilation/data-compilation/data-compilation.component.scss */
.project-container {
  max-width: 700px;
  margin: 40px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.input-field {
  width: 100%;
  margin-bottom: 20px;
}
button {
  margin-bottom: 20px;
  display: block;
}
.table-container {
  overflow-x: auto;
}
table {
  width: 100%;
}
mat-header-row,
mat-row {
  display: flex;
}
mat-header-cell,
mat-cell {
  padding: 10px 10px;
  flex: 1 1 0;
  font-size: 14px;
  overflow: hidden;
  word-break: break-word;
  align-items: center;
  display: flex;
}
.no-data {
  color: #a94442;
  font-weight: bold;
  margin-top: 16px;
}
.dots-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  gap: 8px;
}
.dot {
  width: 12px;
  height: 12px;
  background-color: #3fb582;
  border-radius: 50%;
  animation: pulse 0.6s infinite ease-in-out;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes pulse {
  0%, 100% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}
.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
::ng-deep .mat-internal-form-field > label {
  margin-left: 0;
  margin-right: auto;
  padding-left: 4px;
  padding-right: 0;
  order: 0;
  margin-bottom: 0px;
}
::ng-deep .warning-snackbar .mat-mdc-snackbar-surface {
  background-color: #c01010 !important;
  color: white !important;
  font-weight: bold;
}
/*# sourceMappingURL=data-compilation.component.css.map */
